/**
 * Утилиты для обновления цветов элементов при смене темы
 */

/**
 * Применяет цвета темы к элементу
 */
export const applyThemeToElement = (element, theme) => {
  if (!element || !theme?.elements) return element;

  const elementColors = theme.elements;
  const updatedElement = { ...element };

  switch (element.type) {
    case 'rectangle':
      if (element.isDatabase) {
        // База данных теперь может использовать свои цвета
        const dbColors = elementColors.database || elementColors.rectangle || {};
        updatedElement.fill = dbColors.fill || '#ffffff';
        updatedElement.stroke = dbColors.stroke || '#000000';
        updatedElement.strokeWidth = dbColors.strokeWidth || 2;
      } else if (element.isNote) {
        updatedElement.fill = elementColors.note?.fill || '#fffbe6';
        updatedElement.stroke = elementColors.note?.stroke || '#d4b106';
        updatedElement.strokeWidth = elementColors.note?.strokeWidth || 2;
      } else {
        updatedElement.fill = elementColors.rectangle?.fill || '#ffffff';
        updatedElement.stroke = elementColors.rectangle?.stroke || '#000000';
        updatedElement.strokeWidth = elementColors.rectangle?.strokeWidth || 2;
      }
      break;

    case 'circle':
      updatedElement.fill = elementColors.circle?.fill || '#ffffff';
      updatedElement.stroke = elementColors.circle?.stroke || '#000000';
      updatedElement.strokeWidth = elementColors.circle?.strokeWidth || 2;
      break;

    case 'arrow':
      updatedElement.stroke = elementColors.arrow?.stroke || '#000000';
      updatedElement.strokeWidth = elementColors.arrow?.strokeWidth || 2;
      break;

    case 'text':
      updatedElement.fill = elementColors.text?.fill || '#000000';
      break;

    case 'cylinder':
    case 'database_shape':
    case 'triangle':
    case 'diamond':
    case 'parallelogram':
    case 'rounded_rect':
    case 'ellipse':
    case 'cloud':
    case 'document':
    case 'terminator':
    case 'preparation':
    case 'manual_input':
    case 'manual_operation':
    case 'display':
    case 'data':
    case 'decision':
    case 'process':
    case 'internal_storage':
    case 'queue':
    case 'l_rect':
    case 'u_rect':
    case 'trapezoid':
    case 'inv_trapezoid':
    case 'step':
    case 'callout':
    case 'actor':
    case 'loop_limit':
    case 'storage':
    case 'package':
    case 'use_case':
    case 'interface':
    case 'component':
      // Базовая логика для всех новых фигур - использовать цвета database если стоит флаг isDatabase,
      // иначе цвета прямоугольника
      const baseColors = (element.isDatabase && elementColors.database)
        ? elementColors.database
        : (elementColors.rectangle || {});

      updatedElement.fill = baseColors.fill || '#ffffff';
      updatedElement.stroke = baseColors.stroke || '#000000';
      updatedElement.strokeWidth = baseColors.strokeWidth || 2;
      break;

    default:
      break;
  }

  return updatedElement;
};

/**
 * Обновляет цвета всех элементов согласно текущей теме
 */
export const updateElementsTheme = (elements, theme) => {
  if (!Array.isArray(elements) || !theme) return elements;

  return elements.map(element => applyThemeToElement(element, theme));
};

/**
 * Проверяет, нужно ли обновить цвета элемента (если они не кастомные)
 */
export const shouldUpdateElementTheme = (element, theme) => {
  if (!element || !theme?.elements) return false;

  // Если у элемента есть флаг customColors, не обновляем его
  if (element.customColors) return false;

  const elementColors = theme.elements;

  switch (element.type) {
    case 'rectangle':
      if (element.isDatabase) {
        const dbColors = elementColors.database || elementColors.rectangle || {};
        return element.fill !== dbColors.fill;
      } else if (element.isNote) {
        return element.fill !== elementColors.note?.fill;
      } else {
        return element.fill !== elementColors.rectangle?.fill;
      }

    case 'circle':
      return element.fill !== elementColors.circle?.fill;

    case 'arrow':
      return element.stroke !== elementColors.arrow?.stroke;

    case 'text':
      return element.fill !== elementColors.text?.fill;

    default:
      return false;
  }
};

/**
 * Создаёт элемент с пометкой о кастомных цветах
 */
export const createElementWithCustomColors = (element, customColors = true) => ({
  ...element,
  customColors
});
